var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"daumPostCode"}},[_c('vue-daum-postcode',{on:{"complete":_vm.complete},scopedSlots:_vm._u([{key:"loading",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.locale.data_loading))])]},proxy:true}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }